import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseTimeZone } from '../../common/hooks/useTimeZone'
import { FORMAT, getCurrentDateTime } from '../../helpers/datetime'

export const Content = () => {
  const locale = useSelector((state) => state.i18n.locale)
  const timeZone = UseTimeZone()

  return (
    <Translate
      value="layout.footer.CONTENT"
      year={getCurrentDateTime(FORMAT.YEAR, locale, timeZone)}
    />
  )
}
